import { SiteStats } from './types.js';

export const siteStats: SiteStats = {
  since: 2010,
  locations: 13,
  operationPoints: 25,
  monthlyPlates: 4000000,
};
